import { useState } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
} from '@mui/material';

/**
 * Modal for collecting subdomain before initiating OAuth flow
 * for services that require it (e.g., SharePoint)
 */
const ConnectionSettingsModal = ({ open, service, onSubmit, onCancel }) => {
	const [subdomain, setSubdomain] = useState('');

	const handleSubmit = () => {
		const trimmedSubdomain = subdomain.trim();
		
		if (!trimmedSubdomain) {
			onSubmit(null, 'Subdomain is required');
			return;
		}

		onSubmit({ subdomain: trimmedSubdomain });
	};

	const handleCancel = () => {
		setSubdomain('');
		onCancel();
	};

	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			handleSubmit();
		}
	};

	return (
		<Dialog open={open} onClose={handleCancel} maxWidth='sm' fullWidth>
			<DialogTitle>Configure {service?.name} Connection</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					margin='dense'
					label='SharePoint Subdomain'
					type='text'
					fullWidth
					variant='outlined'
					required
					value={subdomain}
					onChange={(e) => setSubdomain(e.target.value)}
					helperText="Enter your SharePoint subdomain (e.g., 'yourcompany' for yourcompany.sharepoint.com)"
					onKeyPress={handleKeyPress}
					sx={{ mt: 2 }}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleSubmit} variant='contained'>
					Create Connection
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConnectionSettingsModal;
